import type { TypedSelectOption } from "./selectOptions";

declare module "./selectOptions" {
  interface SelectOptionRegistry {
    payment_terms: TypedSelectOption<"payment_terms", {}, PaymentTermType>;
    shipment_billing: TypedSelectOption<
      "shipment_billing",
      {},
      CustomerShipmentBillingType
    >;
    shipping_method: ShippingMethodSelectOption;
  }
}

export const PAYMENT_TERMS = [
  "CREDIT_CARD",
  "DUE_ON_RECEIPT",
  "NET_15",
  "NET_30",
  "NET_45",
  "NET_60",
  "WIRE",
  "UNKNOWN",
] as const;
export type PaymentTermType = (typeof PAYMENT_TERMS)[number];

export const CUST_SHIP_BILLING_TYPES = [
  "CUSTOMER",
  "CENTESE",
  "SPLIT",
] as const;
export type CustomerShipmentBillingType =
  (typeof CUST_SHIP_BILLING_TYPES)[number];

const SHIPPING_PROVIDERS = ["none", "any", "fedex", "ups"] as const;
type ShippingProviderType = (typeof SHIPPING_PROVIDERS)[number];

const NONE_SHIPPING_METHODS = ["None"] as const;
type NoneShippingMethodType = (typeof NONE_SHIPPING_METHODS)[number];

const ANY_SHIPPING_METHODS = [
  "Any",
  "Next Day AM",
  "Next Day Midday",
  "Next Day EOD",
  "2Day AM",
  "2Day EOD",
] as const;
type AnyShippingMethodType = (typeof ANY_SHIPPING_METHODS)[number];

const FEDEX_SHIPPING_METHODS = [
  "Any",
  "First Overnight",
  "Priority Overnight",
  "Standard Overnight",
  "2Day AM",
  "2Day",
  "Express Saver",
  "Ground",
] as const;
type FedexShippingMethodType = (typeof FEDEX_SHIPPING_METHODS)[number];

const UPS_SHIPPING_METHODS = [
  "Any",
  "Next Day Air Early",
  "Next Day Air",
  "2nd Day Air AM",
  "2nd Day Air",
  "3 Day Select",
  "Ground",
] as const;
type UPSShippingMethodType = (typeof UPS_SHIPPING_METHODS)[number];

type ShippingMethodSelectOption<
  SProv extends ShippingProviderType = ShippingProviderType,
> = TypedSelectOption<
  "shipping_method",
  { provider: SProv },
  SProv extends "none"
    ? NoneShippingMethodType
    : SProv extends "any"
      ? AnyShippingMethodType
      : SProv extends "fedex"
        ? FedexShippingMethodType
        : UPSShippingMethodType
>;

export const ShippingMethods = {
  none: { label: "None", methods: ["None"] },
  any: {
    label: "Any",
    methods: [
      "Any",
      "Next Day AM",
      "Next Day Midday",
      "Next Day EOD",
      "2Day AM",
      "2Day EOD",
    ],
  },
  fedex: {
    label: "FedEx",
    methods: [
      "Any",
      "First Overnight",
      "Priority Overnight",
      "Standard Overnight",
      "2Day AM",
      "2Day",
      "Express Saver",
      "Ground",
    ],
  },
  ups: {
    label: "UPS",
    methods: [
      "Any",
      "Next Day Air Early",
      "Next Day Air",
      "2nd Day Air AM",
      "2nd Day Air",
      "3 Day Select",
      "Ground",
    ],
  },
};

const ADDRESS_TYPES = [
  "PRIMARY",
  "BILLING",
  "SHIPPING",
  "OTHER",
] as const;
export type AddressType = (typeof ADDRESS_TYPES)[number];